var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-toggle-selection style-selection page-container" },
    [
      _c(
        "div",
        {
          staticClass: "hero-container",
          style: {
            "--background": "url(" + _vm.imageUrl(_vm.heroImage) + ")",
            "--background-2x": "url(" + _vm.imageUrl(_vm.heroImage2x) + ")"
          },
          on: { touchstart: _vm.dragstart, touchend: _vm.dragend }
        },
        [
          _c(
            "div",
            { staticClass: "vertical-align" },
            [
              _c("div", { staticClass: "hero-hello" }, [
                _vm._v(
                  "\n                Hey " +
                    _vm._s(_vm.user.profile_first_name) +
                    "!\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hero-slide-title" }, [
                _vm._v(
                  "\n                Find outfits you love, styled just for you\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "button", attrs: { to: "/get-styled" } },
                [_vm._v("\n                Get Styled\n            ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "to-saved-outfits",
              attrs: { to: "/saved-outfits" }
            },
            [_vm._v("\n            Go To Saved Outfits\n        ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-176b04bf", { render: render, staticRenderFns: staticRenderFns })
  }
}